const dictionary = {
  welcomeHeading: {
    en: 'Exclusive Preview Trip Offer',
    ru: 'Эксклюзивная поездка для предварительного просмотра',
    cn: '独家看房游'
  },
  welcomeSubHeading: {
    en: 'Thank you for your interest in our properties. To find out if you are eligible for a complimentary preview trip to Phuket, please fill in the information below and our Sales Team will get back to you shortly. Please note that fields marked with an asterisk (*) are mandatory.',
    ru: 'Спасибо за ваш интерес к нашей недвижимости. Чтобы узнать, сможете ли Вы оформить бесплатную  поездку на Пхукет для предварительного просмотра, просьба, заполнить форму приведенную ниже. Наш отдел продаж свяжется с вами в ближайшее время. Обратите внимание, что поля, отмеченные звездочкой (*), являются обязательными для заполнения.',
    cn: '感谢您关注我们的项目。欲享独家看房游，请填写以下详细信息，我们的销售团队将尽快与您联系。请注意，标有星号（*）为必填栏。'
  },
  basicInformation: {
    en: 'Basic Information',
    ru: 'Общая информация',
    cn: '基本信息'
  },
  title: {
    en: 'Title',
    ru: 'Обращение',
    cn: '称谓'
  },
  name: {
    en: 'Name',
    ru: 'имя',
    cn: '名'
  },
  firstName: {
    en: 'First Name',
    ru: 'Имя',
    cn: '名'
  },
  lastName: {
    en: 'Last Name',
    ru: 'Фамилия',
    cn: '姓'
  },
  email: {
    en: 'Email',
    ru: 'эл почта',
    cn: '电邮'
  },
  phone: {
    en: 'Phone',
    ru: 'телефон',
    cn: '电话'
  },
  mobilePhone: {
    en: 'Mobile Phone',
    ru: 'Номер тел (моб)',
    cn: '电话'
  },
  landPhone: {
    en: 'Land Phone',
    ru: 'телефон',
    cn: '电话'
  },
  city: {
    en: 'City',
    ru: 'Город',
    cn: '城市'
  },
  country: {
    en: 'Country',
    ru: 'Страна',
    cn: '国家'
  },
  nationality: {
    en: 'Nationality',
    ru: 'Национальность',
    cn: '国籍'
  },
  location: {
    en: 'Location',
    ru: 'места',
    cn: '居住地'
  },
  investmentOptions: {
    en: 'Investment Options',
    ru: 'Инвестиционная опция',
    cn: '投资选项'
  },
  selectCurrency: {
    en: 'Please select your currency',
    ru: 'Выберите валюту',
    cn: '请选择币种'
  },
  selectBudget: {
    en: 'Please select your current investment budget',
    ru: 'Выберите текущий инвестиционный бюджет',
    cn: '请选择您现有投资预算'
  },
  interested: {
    en: 'I am interested!',
    ru: 'Я заинтересован!',
    cn: '我很感兴趣',
  },
  almostThere: {
    en: 'Almost there; just a couple more questions',
    ru: 'Почти готово; еще пара вопросов',
    cn: '快到了，还有几个问题',
  },
  question1: {
    en: 'Do you already have investment(s) in Thailand or Indonesia?',
    ru: 'Совершали ли  Вы инвестирование в Таиланде?',
    cn: '您是否已在泰国投资房产？',
  },
  question2: {
    en: 'Do you already have investment(s) with Banyan Tree Group properties or its subsidiaries?',
    ru: 'Инвестировали ли Вы в недвижимость Лагуны или ее дочерние компании до этого момента?',
    cn: '您是否已购入乐古浪及其相关公司房产？',
  },
  yes: {
    en: 'Yes',
    ru: 'Да',
    cn: '是',
  },
  no: {
    en: 'No',
    ru: 'Нет',
    cn: '否',
  },
  submit: {
    en: 'Submit',
    ru: 'Отправить',
    cn: '提交',
  },
  goBack: {
    en: 'Back to our full site',
    ru: 'Вернуться на сайт',
    cn: '返回乐古浪房产网站'
  },
  thankyou: {
    en: 'Thank you for submitting your inquiry regarding our complimentary preview trip offer. Our Sales Team will contact you shortly to discuss about your investment opportunities.',
    ru: 'Спасибо за отправку вашего запроса относительно специального бесплатного предложения тура предварительного просмотра. Наш отдел продаж свяжется с Вами в ближайшее время, чтобы обсудить инвестиционные возможности.',
    cn: '感谢您提交独家免费看房游的申请,我们的销售团队将尽快联系您。'
  },
  term: {
    en: 'Term of use',
    ru: 'ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ',
    cn: '隐私保护政策'
  },
  viewFullSite: {
    en: 'VIEW FULL SITE',
    ru: 'Посмотреть Полный Сайт',
    cn: '阅读完整内容'
  },
  privacy: {
    en: 'Privacy Policy',
    ru: 'ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ',
    cn: '使用条款'
  },
  cookiePrivacy: {
    en: 'We use cookies on this site to improve your user experience. By continuing to use this site, you are agreeing to our',
    ru: 'используем файлы cookie на этом сайте, чтобы улучшить ваш пользовательский интерфейс. Продолжая использовать этот сайт, вы соглашаетесь с нашей',
    cn: '我们在此网站使用了cookies来改善你的用户体验。继续访问网站，表示您同意我们的'
  },
  cookiePrivacyLink: {
    en: 'Privacy Policy',
    ru: 'Политикой Конфиденциальности',
    cn: '隐私政策。'
  },
  accept: {
    en: 'I ACCEPT',
    ru: 'ПРИНИМАЮ',
    cn: '同意'
  },
  backToPrevious: {
    en: 'Back to previous page',
    ru: 'Назад к предыдущей странице',
    cn: '回到上一页'
  },
  fieldRequired: {
    en: 'This field is required.',
    ru: 'Эта строка должна быть заполнена.',
    cn: '此处为必填项'
  }
}

export default dictionary


// WEBPACK FOOTER //
// ./src/data/PreviewTrip/dictionary.js